import {
  isAllowedMobileContentPath,
  WRITER_MOBILE_CONTENT_PATHS,
} from "@/components/site/mobile-content-gate";

export type DashboardRouteFrameState = {
  mainClassName: string;
  sidebarClassName: string;
  viewportClassName: string;
  writerRoute: boolean;
};

export function getDashboardRouteFrameState(pathname: string): DashboardRouteFrameState {
  const writerRoute = isAllowedMobileContentPath(pathname, WRITER_MOBILE_CONTENT_PATHS);

  return {
    mainClassName: writerRoute
      ? "min-w-0 px-[max(0.5rem,env(safe-area-inset-left))] pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-[max(0.5rem,env(safe-area-inset-top))] sm:px-3 sm:pb-3 sm:pt-3 lg:p-4 xl:p-5"
      : "min-w-[960px] p-5",
    sidebarClassName: "contents",
    viewportClassName: writerRoute ? "h-[100dvh] max-h-[100dvh]" : "h-screen",
    writerRoute,
  };
}
